import { fromBusinessDto } from '../business/toBusinessModel';
import type { UserDto, UserModel } from '../../data-layer/user/types';

export enum BusinessRegistrationStatus {
    REGISTERED = 'registered',
    MODERATION = 'moderation',
    VERIFICATION = 'verification',
    DECLINED_FOR_BETA = 'declined_for_beta',
    DECLINED = 'declined',
    NOT_REGISTERED = 'not_registered',
}

export const fromUserDto = (userDto: UserDto): UserModel => ({
    id: userDto.id,
    subscriptions: userDto.subscriptions,
    avatarUrl: userDto.yandex_avatar_url,
    displayName: userDto.yandex_public_name,
    login: userDto.yandex_login,
    profile: 'profile' in userDto ? fromBusinessDto(userDto) : undefined,
    role: userDto.role,
    businessRegistrationStatus: userDto.business_registration_status,
    yandexEmail: userDto.yandex_email,
});
